import React from "react";
import ReactDOM from "react-dom";

import { observer, inject, Provider } from "mobx-react";

import { extendObservable } from 'mobx';


@inject('core')
@observer
export default class Quantity extends React.Component {
	
	constructor(props) {
		super(props)
		this.changeNeeds = this.changeNeeds.bind(this)
	}	
	
	componentDidMount() {
		const { core } = this.props
	}
		
	changeNeeds(product_id, change_delta = undefined) {
		const { core } = this.props

		if (typeof change_delta === 'undefined') {
		
			var needs = window.prompt('Needed:', core.products.find( p => p.product_id == product_id ).needs)
			
			if ((typeof needs !== 'undefined') && (needs !== null)) {
				core.action({
					op:'setNeeds', 
					product_id, 
					needs: needs
				})
			}
		}
		else {
			core.action({ op: 'setNeeds', product_id: product_id, needs: core.products.find( p => p.product_id == product_id ).needs + change_delta })
		}
	}
	

	render() {
		const { core, product_id } = this.props
		
		const product = core.products.find(p => p.product_id == product_id)
		if (typeof product === 'undefined') {
			return <div>Unknown Product</div>
		}
		
		return <div id="single-needs-line" className="product-line">
			<span className="needs-button clickable" onClick={() => this.changeNeeds(product.product_id)}> {product.needs}</span>
			<span key="need-inc" className="needs-button-inc clickable needs-stepper" onClick={() => this.changeNeeds(product.product_id, +1)}>+</span>
			<span key="need-dec" className="needs-button-dec clickable needs-stepper" onClick={() => this.changeNeeds(product.product_id, -1)}>-</span>
		</div>
	}
	
}


